import mifosRepository, { MifosRepository } from "./MifosRepository";

const resourceLoans = "/loans";
const resourceLoanProduct = "/loanproducts";
export default {
  getLoanById(loanId) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceLoans}/${loanId}`);
  },

  getAllLoans(offset, limit, accountNo, externalId, orderBy, sortOrder, sqlSearch, dataTableToJoin,
    dataTableFilterCondition) {
    const queryParams = {
      'offset': offset,
      'limit': limit,
      'accountNo': accountNo,
      'externalId': externalId,
      'orderBy': orderBy,
      'sortOrder': sortOrder,
      'sqlSearch': sqlSearch,
      'dataTableToJoin': dataTableToJoin,
      'dataTableFilterCondition': dataTableFilterCondition
    };
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceLoans}`, { params: queryParams });
  },

  getLoanProductById(loanProductId) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceLoanProduct}/${loanProductId}`);
  },

  updateLoansAccount(loanId, loansPayload) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.put(`${resourceLoans}/${loanId}`, loansPayload);
  },

  getLoanAccountDetailsByAccountNumber(accountNumber){
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resourceLoans}/account/${accountNumber}`);
  }
};
